import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className?: string;
  $pl?: string | number;
  $pr?: string | number;
  $pt?: string | number;
  $pb?: string | number;
  $align?: string;
  bdt?: string;
  bdb?: string;
  $ml?: string | number;
  $mr?: string | number;
  $mt?: string | number;
  $mb?: string | number;
  $bgColor?: string;
  $rowGap?: number;
  $colGap?: number;
}

export const Box = styled.div<IProps>`
  padding-left: ${({ $pl }) => (typeof $pl === 'number' ? `${$pl}px` : $pl)};
  padding-right: ${({ $pr }) => (typeof $pr === 'number' ? `${$pr}px` : $pr)};
  padding-top: ${({ $pt }) => (typeof $pt === 'number' ? `${$pt}px` : $pt)};
  padding-bottom: ${({ $pb }) => (typeof $pb === 'number' ? `${$pb}px` : $pb)};
  margin-left: ${({ $ml }) => (typeof $ml === 'number' ? `${$ml}px` : $ml)};
  margin-right: ${({ $mr }) => (typeof $mr === 'number' ? `${$mr}px` : $mr)};
  margin-top: ${({ $mt }) => (typeof $mt === 'number' ? `${$mt}px` : $mt)};
  margin-bottom: ${({ $mb }) => (typeof $mb === 'number' ? `${$mb}px` : $mb)};
  border-top: ${({ bdt }) => bdt};
  border-bottom: ${({ bdb }) => bdb};
  background: ${({ $bgColor }) => $bgColor};
  row-gap: ${({ $rowGap }) => `${$rowGap || 0}px`};
  column-gap: ${({ $colGap }) => `${$colGap || 0}px`};

  ${props => {
    if (props.$rowGap || props.$colGap) {
      return css`
        ${mixin.flex({ justify: 'flex-start' })}
      `;
    }
    return null;
  }};

  ${props => {
    if (props.$align === 'center') {
      return css`
        ${mixin.flex({ justify: 'center' })}
      `;
    }
    if (props.$align === 'right') {
      return css`
        ${mixin.flex({
          justify: 'flex-end',
        })}
      `;
    }
    return null;
  }};

  @media ${({ theme }) => theme.media.smMax} {
    padding-left: ${({ $pl }) =>
      typeof $pl === 'number' ? `${mixin.pxToVw(String($pl))}` : $pl};
    padding-right: ${({ $pr }) =>
      typeof $pr === 'number' ? `${mixin.pxToVw(String($pr))}` : $pr};
    padding-top: ${({ $pt }) =>
      typeof $pt === 'number' ? `${mixin.pxToVw(String($pt))}` : $pt};
    padding-bottom: ${({ $pb }) =>
      typeof $pb === 'number' ? `${mixin.pxToVw(String($pb))}` : $pb};
    margin-left: ${({ $ml }) =>
      typeof $ml === 'number' ? `${mixin.pxToVw(String($ml))}` : $ml};
    margin-right: ${({ $mr }) =>
      typeof $mr === 'number' ? `${mixin.pxToVw(String($mr))}` : $mr};
    margin-top: ${({ $mt }) =>
      typeof $mt === 'number' ? `${mixin.pxToVw(String($mt))}` : $mt};
    margin-bottom: ${({ $mb }) =>
      typeof $mb === 'number' ? `${mixin.pxToVw(String($mb))}` : $mb};
    row-gap: ${({ $rowGap }) => `${mixin.pxToVw(String($rowGap || 0))}`};
    column-gap: ${({ $colGap }) => `${mixin.pxToVw(String($colGap || 0))}`};
  }
`;
